import { render, staticRenderFns } from "./BeaconEditor.vue?vue&type=template&id=028e3c98&"
import script from "./BeaconEditor.vue?vue&type=script&lang=ts&"
export * from "./BeaconEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports